import { useState, useEffect } from "react";
import { cards } from "../../lib/api/api";
import { Link } from "react-router-dom";

import { HandySvg } from 'handy-svg';
import iconArrowRight from '../../assets/icons/svg-sprite/arrow-right.svg';
import iconCross from '../../assets/icons/svg-sprite/close-cross--alt.svg';
import iconOKFull from '../../assets/icons/svg-sprite/odnoklassniki-full.svg';
import iconThumbUp from '../../assets/icons/svg-sprite/thumb-up.svg';
import iconVKFull from '../../assets/icons/svg-sprite/vkontakte-full.svg';
import iconCallback from '../../assets/images/elems/button_callback_white.png';

import activationCardModal from "../../modules/activation-card-modal";
import addMenuOpenerInMobileMenu from "../../modules/add-menu-in-mobile-menu";
import toggleMobileMenu from '../../modules/toggle-mobile-menu';

const MobileMenu = () => {
    const [ID, setID] = useState(0);
    const [region, setRegion] = useState('');

    useEffect(() => {
        activationCardModal();
        addMenuOpenerInMobileMenu();
        toggleMobileMenu();
        cards.userCard()
            .then((res) => {
                setID(res[0].id);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        if (ID !== 0) {
            cards.card(ID)
                .then((res) => {
                    const address = res.address.sort((a, b) => a.type_id < b.type_id ? 1 : -1);
                    address.forEach(item => {
                        item.type_id === 3 ? setRegion(item.value) :
                        item.type_id === 2 ? setRegion(`${item.value} ${item.add}`) :
                        item.type_id === 1 ? setRegion(`${item.value} ${item.add}`) :
                        setRegion('Не указан');
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [ID]);

    return (
        <>
            <div className="mobile-menu-overlay js-mobile-menu-overlay"></div>
            <section className="mobile-menu js-mobile-menu">
                <h6 className="visuallyhidden">Меню для мобильных устройств</h6>
                <div className="mobile-menu__head">
                    <div className="mobile-menu__container mobile-menu__head-inner">
                        <button className="mobile-menu__close-btn js-mobile-menu-closer" type="button">
                            <HandySvg className="svg-icon" src={iconCross} width="12" height="12"/>
                        </button>
                        <div className="mobile-menu__head-right-section">
                            <button className="mobile-menu__call-link bttn js-support-callback-trigger" type="button" style={{textAlign: 'right'}}>
                                <img src={iconCallback} width="80%"/>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="mobile-menu__region-wrap mobile-menu__section">
                    <div className="mobile-menu__container">
                        <span className="mobile-menu__region-label">Ваш регион</span>
                        <button className="mobile-menu__region-btn" type="button">{region}</button>
                    </div>
                </div>
                <div className="mobile-menu__all-site-wrap mobile-menu__section">
                    <div className="mobile-menu__container">
                        <div className="mobile-menu__all-site js-add-menu-parent">
                            <button className="mobile-menu__nav-btn js-add-menu-opener" type="button">Весь сайт
                                <HandySvg className="svg-icon" src={iconArrowRight} width="16" height="16"/>
                            </button>
                            <ul className="mobile-menu__add-menu-list js-add-menu">
                                <li className="mobile-menu__add-menu-item">
                                    <Link className="mobile-menu__add-menu-link" to='/'>Личный кабинет</Link>
                                </li>
                                <li className="mobile-menu__add-menu-item">
                                    <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/payment/'>Оплата</Link>
                                </li>
                                <li className="mobile-menu__add-menu-item">
                                    <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/exchange/'>Обмен приемника</Link>
                                </li>
                                <li className="mobile-menu__add-menu-item">
                                    <Link className="mobile-menu__add-menu-link" to='//shop.telekarta.tv'>Интернет-магазин</Link>
                                </li>
                                <li className="mobile-menu__add-menu-item">
                                    <Link className="mobile-menu__add-menu-link" to='//onlinetv.telekarta.tv/#login' target="_blank">Телекарта кинотеатр</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mobile-menu__navigation-wrap mobile-menu__section">
                    <div className="mobile-menu__container">
                        <nav className="mobile-menu__nav">
                            <ul className="mobile-menu__nav-list">
                                <li className="mobile-menu__nav-item">
                                    <Link className="mobile-menu__nav-link" to='//telekarta.tv/payment/'>Оплата</Link>
                                </li>
                                <li className="mobile-menu__nav-item">
                                    <Link className="mobile-menu__nav-link" to='//telekarta.tv/actions/'>Акции</Link>
                                </li>
                                <li className="mobile-menu__nav-item">
                                    <Link className="mobile-menu__nav-link" to='//telekarta.tv/bonus/'>Телекарта Бонус</Link>
                                </li>
                                <li className="mobile-menu__nav-item">
                                    <Link className="mobile-menu__nav-link" to='//shop.telekarta.tv'>Оборудование</Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="mobile-menu__navigation-wrap mobile-menu__section">
                    <div className="mobile-menu__container">
                        <nav className="mobile-menu__nav">
                            <ul className="mobile-menu__nav-list">
                                <li className="mobile-menu__nav-item js-add-menu-parent">
                                    <button className="mobile-menu__nav-btn js-add-menu-opener" type="button">Подключение
                                        <HandySvg className="svg-icon" src={iconArrowRight} width="16" height="16"/>
                                    </button>
                                    <ul className="mobile-menu__add-menu-list js-add-menu">
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/where_to_buy/'>Где купить?</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/subscription_agreement/'>Абонентский договор</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//shop.telekarta.tv'>Интернет магазин</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//onlinetv.telekarta.tv'>Телекарта Онлайн</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="mobile-menu__nav-item js-add-menu-parent">
                                    <button className="mobile-menu__nav-btn js-add-menu-opener" type="button">Абонентам
                                        <HandySvg className="svg-icon" src={iconArrowRight} width="16" height="16"/>
                                    </button>
                                    <ul className="mobile-menu__add-menu-list js-add-menu">
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/payment/'>Оплатить подписку</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/exchange/'>Обменять оборудование</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/actions/'>Акции</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/tvprogram/'>Телепрограмма</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/bonus/'>Телекарта Бонус</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/instructions/'>Инструкции</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/where_to_buy?type=service'>Гарантийное обслуживание</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="mobile-menu__nav-item js-add-menu-parent">
                                    <button className="mobile-menu__nav-btn js-add-menu-opener" type="button">О Телекарте
                                        <HandySvg className="svg-icon" src={iconArrowRight} width="16" height="16"/>
                                    </button>
                                    <ul className="mobile-menu__add-menu-list js-add-menu">
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/about/'>О Телекарте</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/contacts/'>Контакты и реквизиты</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/licenses/'>Лицензия</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='//telekarta.tv/partners/'>Партнёрам</Link>
                                        </li>
                                        <li className="mobile-menu__add-menu-item">
                                            <Link className="mobile-menu__add-menu-link" to='https://old.telekarta.tv/connect/oborudovanie.html'>Архив оборудования</Link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="mobile-menu__evaluation mobile-menu__section">
                    <div className="mobile-menu__container">
                        <button className="quality-offer js-init-callback-form" type="button">
                            <HandySvg className="svg-icon" src={iconThumbUp} width="16" height="16"/>
                            <span className="quality-offer__text">Оцените качество обслуживания</span>
                        </button>
                    </div>
                </div>
                <div className="mobile-menu__social mobile-menu__section">
                    <section className="socials-rainbow">
                        <h6 className="visuallyhidden">Ссылки на социальные сети</h6>
                        <Link className="socials-rainbow__link" to='https://vk.com/tvtelekarta' target="_blank">
                            <span className="visuallyhidden">Ссылка на группу вконтакте</span>
                            <HandySvg className="svg-icon" src={iconVKFull} width="40" height="40"/>
                        </Link>
                        <Link className="socials-rainbow__link" to='https://ok.ru/telekarta.tv' target="_blank">
                            <span className="visuallyhidden">Ссылка на группу в одноклассниках</span>
                            <HandySvg className="svg-icon" src={iconOKFull} width="40" height="40"/>
                        </Link>
                    </section>
                </div>
            </section>
        </>
    );
};

export default MobileMenu;